import { useState } from "react";
import { post } from "@aws-amplify/api-rest";
import { NEW_REST_API } from "../../../consts";
import { Upload, Button, message } from "antd";
import { rootStore } from "../../../stores/Root";
import { UploadOutlined } from "@ant-design/icons";
import { RcFile } from "antd/lib/upload";

export const UploadFont = ({ accountId }: { accountId: string }) => {
  const [file, setFile] = useState<File | null>(null);

  const handleUpload = async () => {
    if (!file) return;
    try {
      if (!accountId) {
        throw new Error("ERR_NO_GROUP_SELECTED");
      }

      if (!file) return;

      // Wrap FileReader in a Promise to await its completion
      const readFileAsDataURL = (file: RcFile): Promise<string> => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e) => {
            const dataUrl = e.target?.result;
            if (typeof dataUrl === "string") {
              resolve(dataUrl);
            } else {
              reject("Failed to read file as Data URL.");
            }
          };
          reader.onerror = (error) => {
            reject(error);
          };
          reader.readAsDataURL(file);
        });
      };

      const dataUrl = await readFileAsDataURL(file as RcFile);

      // Extract the base64 string from the Data URL.
      const base64Data = dataUrl.split(",")[1];
      // Prepare the payload expected by the /font endpoint.
      const myInit = {
        crossDomain: true,
        body: {
          font: {
            data: base64Data,
            fileName: file.name,
          },
        },
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        data: true,
      };
      try {
        // Post the payload to your API.
        const response = await post({
          apiName: NEW_REST_API,
          path: `/v2/private/account/${accountId}/font`,
          options: myInit,
        }).response;

        if (response.statusCode === 200) {
          const responseBody = (await response.body.json()) as {
            url: string;
          };
          const fontUrl = responseBody?.url;
          if (!fontUrl) {
            throw new Error("ERR_NO_FONT_URL");
          }
          message.success(`${file.name} file uploaded successfully`);
          rootStore.userStore.load();
        } else {
          message.error(`${file.name} file upload failed.`);
        }
      } catch (error) {
        message.error(`${file.name} file upload failed.`);
      }
    } catch (error) {
      message.error(`${file.name} file upload failed.`);
    } finally {
    }
  };

  return (
    <div style={{ display: "flex", gap: 8 }}>
      <Upload
        accept=".ttf"
        id="fontInput"
        onChange={(info) => {
          const selectedFile = info.file.originFileObj;
          setFile(selectedFile || null);
        }}
      >
        <Button icon={<UploadOutlined />}>Select File</Button>
      </Upload>
      <Button id="uploadBtn" onClick={handleUpload} disabled={!file}>
        Upload
      </Button>
    </div>
  );
};
